/**
 * API Configuration
 * All data calls go through the Node.js server (selfOrderController endpoints).
 * Firebase is used only for Auth (ID tokens sent as Bearer) and Firestore
 * onSnapshot triggers (real-time push → then REST fetch for actual data).
 */

import {
  initializeFirebase,
  firebaseAuth,
  applyPromoCode,
} from '../services/api/firebaseAdapter.jsx';

import {
  getPublicRestaurant,
  getMenuItems,
  getCustomerReviews,
  getRestaurantTheme,
  getSelfOrderSettings,
  submitOrder,
  getOrdersByUserId,
  getSelfOrderById,
  updateOrderStatus,
  getPromotions,
  createCartHold,
  createPaymentOrder,
  getPaymentStatus,
} from '../services/api/restApiAdapter.js';

export const API_PROVIDERS = {
  MOCK: 'mock',
  FIREBASE: 'firebase',
  REST_API: 'rest_api',
};

export const CURRENT_API_PROVIDER = API_PROVIDERS.REST_API;

export const createApiProvider = () => ({
  // ── Public (REST → selfOrderController) ──────────────────────────────────
  getPublicRestaurant,
  getMenuItems,
  getCustomerReviews,
  getRestaurantTheme,
  getSelfOrderSettings,
  getPromotions,

  // ── Orders (REST → selfOrderController) ──────────────────────────────────
  submitOrder,
  getOrdersByUserId,
  getSelfOrderById,
  updateOrderStatus,

  // ── Cart-Hold / showCode mode (REST → selfOrderController) ───────────────
  createCartHold,

  // ── Payment / payAndOrder mode (REST → selfOrderController → Razorpay) ───
  createPaymentOrder,
  getPaymentStatus,

  // ── Promo codes (Firebase Cloud Function — no REST equivalent yet) ────────
  applyPromoCode,
});

export const API_CONFIG = {
  REST_API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.swadho.com/api/v1',
  REST_API_TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
  CACHE_DURATION: 5 * 60 * 1000,
};

export const FEATURE_FLAGS = {
  ENABLE_OFFLINE_MODE: true,
  ENABLE_CART_PERSISTENCE: true,
  ENABLE_PROMO_CODES: true,
  ENABLE_REAL_TIME_UPDATES: true, // Firestore onSnapshot trigger → REST fetch
};

export { initializeFirebase, firebaseAuth };

export default {
  API_PROVIDERS,
  CURRENT_API_PROVIDER,
  createApiProvider,
  API_CONFIG,
  FEATURE_FLAGS,
};